import { render } from "./FuentesMacroCrearActualizarComponent.vue?vue&type=template&id=30b31805"
import script from "./FuentesMacroCrearActualizarComponent.vue?vue&type=script&lang=js"
export * from "./FuentesMacroCrearActualizarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__